import api from './api';

export interface AnalyticsDashboardResponse {
  users: {
    totalEmployees: number;
    roleDistribution: Array<{ role: string; count: number }>;
    profileCompletionRate: number;
  };
  posts: {
    totalPosts: number;
    postsByCategory: Array<{ category: string; count: number }>;
    postsByDepartment: Array<{ department: string; count: number }>;
    mostLikedPosts: Array<{
      postId: string;
      caption: string;
      category: string;
      department: string | null;
      createdAt: string;
      createdByName: string;
      likeCount: number;
    }>;
    mostCommentedPosts: Array<{
      postId: string;
      caption: string;
      category: string;
      department: string | null;
      createdAt: string;
      createdByName: string;
      commentCount: number;
    }>;
    mostActiveUsers: Array<{
      userId: string;
      fullName: string;
      role: string;
      department: string;
      profilePicture: string | null;
      postsCreated: number;
      likesGiven: number;
      commentsMade: number;
      totalActivity: number;
    }>;
  };
  policies: {
    totalActivePolicies: number;
    policiesRequiringAcceptance: number;
    acceptanceRatePerPolicy: Array<{
      policyId: string;
      title: string;
      type: string;
      acceptedUsers: number;
      totalEmployees: number;
      acceptanceRate: number;
    }>;
    usersWithAllPoliciesAcceptedVsPending: {
      totalUsers: number;
      usersWithAllPoliciesAccepted: number;
      usersWithPendingPolicies: number;
    };
    policyAcceptancesGroupedByUser: Array<{
      userId: string;
      fullName: string;
      role: string;
      department: string;
      acceptedPolicies: number;
      requiredPolicies: number;
      pendingPolicies: number;
      complianceRate: number;
      isCompliant: boolean;
    }>;
    acceptanceTrend: Array<{ period: string; count: number }>;
    nonCompliantUsers: Array<{
      userId: string;
      fullName: string;
      role: string;
      department: string;
      acceptedPolicies: number;
      requiredPolicies: number;
      pendingPolicies: number;
      complianceRate: number;
      isCompliant: boolean;
    }>;
  };
  notifications: {
    totalNotificationsSent: number;
    readVsUnreadRate: {
      readCount: number;
      unreadCount: number;
      readRate: number;
      unreadRate: number;
    };
    notificationsByType: Array<{ type: string; count: number }>;
  };
}

export const analyticsService = {
  async getDashboard(): Promise<AnalyticsDashboardResponse> {
    const response = await api.get('/analytics/dashboard');
    return response.data;
  },
};
